<hr class="w-4rem h-1 mt-4 mb-3 mx-0 border-top-3 border-gray-400">
<ng-container *ngIf="companyInfoDetail$ | async as companyInfoDetail">
  <p class="text-gray-600">Grip Technologies Pvt Ltd. All rights reserved. <a *ngIf="companyInfoDetail.compDetails.is_terms_of_service_url" [href]="companyInfoDetail.terms_of_service_url" 
      class="font-medium text-600 no-underline hover:text-primary cursor-pointer transition-colors transition-duration-150">Terms
      of Use</a> | <a *ngIf="companyInfoDetail.compDetails.is_privacy_policy_url" [href]="companyInfoDetail.compDetails.privacy_policy_url"
      class="font-medium text-600 no-underline hover:text-primary cursor-pointer transition-colors transition-duration-150">Privacy
      Policy</a> </p>

  <img class="mt-2" width="113" src="/assets/img/fitness-logo.svg" alt="Fitness Logo" />
</ng-container>